
import { defineComponent, PropType } from 'vue';
import { useProcessAvatar } from '@/composables';
import { Reaction } from '@/components/reaction';
import { CardCommentItem } from './types';

export default defineComponent({
  components: {
    Reaction,
  },
  props: {
    comment: { type: Object as PropType<CardCommentItem>, required: true },
  },
  emits: ['click-avatar', 'click-star'],
  setup() {
    const { processAvatar } = useProcessAvatar();
    return {
      processAvatar,
    };
  },
  computed: {
    starColor(): string {
      return this.comment.starred ? '#ef755a' : '';
    },
    timeDiff() {
      const res: string = this.comment.createdAt.fromNow();
      return res;
    },
  },
  methods: {
    handleClickAvatar() {
      this.$emit('click-avatar', this.comment.creator.id);
    },
    handleClickStar() {
      this.$emit('click-star', this.comment.id);
    },
  },
});
